import React from 'react'
import { Grid, Row, Panel, Table } from 'rsuite'

export default function ProgessOutcomeView(props) {
  const { Column, HeaderCell, Cell } = Table

  const { schema } = props

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Table
              isTree
              defaultExpandAllRows
              rowKey="id"
              cellBordered
              // height={400}
              autoHeight
              wordWrap
              data={schema?.values || []}
            >
              <Column width={500}>
                <HeaderCell>{schema.columnText1}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.label || rowData.expectedOutcome
                  }}
                </Cell>
              </Column>

              <Column width={'auto'}>
                <HeaderCell>{schema.columnText2}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return (
                      <div dangerouslySetInnerHTML={{ __html: rowData.actualOutcome }}></div>

                      // <div
                      //   style={{ whiteSpace: 'pre-line' }} // ใส่เพื่อให้ render \n ได้
                      //   dangerouslySetInnerHTML={{
                      //     __html: rowData.actualOutcome,
                      //   }}
                      // />
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </Grid>
        </Panel>
      </Row>
    </div>
  )
}
